export * from './buscador-colaboradores-filter.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/buscador/buscador-colaboradores-filter/index.ts